export const peopleSearchRoutes = [
  {
    path: '/peoplesearch',
    lazy: async () => {
      const { PeopleSearchRoute } =
        await import('./PeopleSearchRoute/PeopleSearchRoute');
      return { Component: PeopleSearchRoute };
    },
  },
  {
    path: '/peoplesearch/preparing',
    lazy: async () => {
      const { PreparingRoute } =
        await import('./PreparingRoute/PreparingRoute');
      return { Component: PreparingRoute };
    },
  },
  {
    path: '/peoplesearch/collecting-data',
    lazy: async () => {
      const { CollectingDataRoute } =
        await import('./CollectingDataRoute/CollectingDataRoute');
      return { Component: CollectingDataRoute };
    },
  },
  {
    path: '/peoplesearch/results-ready',
    lazy: async () => {
      const { ResultsReadyRoute } =
        await import('./ResultsReadyRoute/ResultsReadyRoute');
      return { Component: ResultsReadyRoute };
    },
  },
  {
    path: '/peoplesearch/login',
    handle: {
      authEntryRedirect: (search: string) => `/peoplesearch/plan${search}`,
    },
    lazy: async () => {
      const { LoginRoute } = await import('../../Login/Login');
      return { Component: LoginRoute };
    },
  },
  {
    path: '/peoplesearch/register',
    handle: {
      authEntryRedirect: (search: string) => `/peoplesearch/plan${search}`,
    },
    lazy: async () => {
      const { RegisterRoute } = await import('../../Register/Register');
      return { Component: RegisterRoute };
    },
  },
  {
    path: '/peoplesearch/forgot-password',
    handle: {
      authEntryRedirect: (search: string) => `/peoplesearch/plan${search}`,
    },
    lazy: async () => {
      const { ForgotPasswordRoute } =
        await import('../../ForgotPassword/ForgotPassword');
      return { Component: ForgotPasswordRoute };
    },
  },
];

export const protectedPeopleSearchRoutes = [
  {
    path: '/peoplesearch',
    lazy: async () => {
      const { PeopleSearchRoute } =
        await import('./PeopleSearchRoute/PeopleSearchRoute');
      return { Component: PeopleSearchRoute };
    },
  },
  {
    path: '/peoplesearch/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./PlanRoute/PlanRoute');
      return { Component: PlanRoute };
    },
  },
];
